var exports = {
  "v_": "DiscoveryNavbar.module__navbar___dXJ4Wk",
  "Bx": "DiscoveryNavbar.module__leftSection___dXJ4Wk",
  "LY": "DiscoveryNavbar.module__leftSurface___dXJ4Wk",
  "Gv": "DiscoveryNavbar.module__backButton___dXJ4Wk",
  "dc": "DiscoveryNavbar.module__searchTitle___dXJ4Wk",
  "$L": "DiscoveryNavbar.module__categoryTabs___dXJ4Wk",
  "Wu": "DiscoveryNavbar.module__categoryTab___dXJ4Wk",
  "KB": "DiscoveryNavbar.module__categoryTabActive___dXJ4Wk" + " " + "DiscoveryNavbar.module__categoryTab___dXJ4Wk",
  "uk": "DiscoveryNavbar.module__searchArea___dXJ4Wk",
  "rm": "DiscoveryNavbar.module__searchForm___dXJ4Wk",
  "qc": "DiscoveryNavbar.module__searchIcon___dXJ4Wk",
  "Rt": "DiscoveryNavbar.module__searchInput___dXJ4Wk",
};

module.exports = exports;
